'use strict';

const DatePresenter = require('../presenters/date');

const BaseView = require('./base');

class DateView extends BaseView {
  tagName() {
    return 'li';
  }

  constructor() {
    super(...arguments);
  }

  initialize() {
    this.setModule('glive_booking_redesign');
    this.presenter = DatePresenter;
    this.templateName = 'date';
  }

  events() {
    return { click: 'select' };
  }

  select(args, kill = false) {
    if (!kill) {
      $(args.toElement).trigger('click', true);
      this.trigger('select', this.model);
    }
  }
}

module.exports = DateView;
